module.exports = __webpack_public_path__ + "img/questions.4b88bce6.svg";